import { useState } from "react";
import "./index.scss";
import { useTranslation } from 'react-i18next';

interface NumeratorProps {
  setPage: (pageNo: number) => void;
  closeNumerator: () => void;
}

const Numerator: React.FC<NumeratorProps> = ({ setPage, closeNumerator }) => {
  const [input, setInput] = useState<string>("");
  const { t } = useTranslation('translation', { keyPrefix: 'page_numerator' });

  const loadPage = (value: string) => {
    setPage(parseInt(value, 10));
    closeNumerator();
  };

  const handleClick = (value: string | number) => {
    if (value === "enter") {
      loadPage(input);
      setInput("");
    } else if (value === "delete") {
      setInput(input.slice(0, -1));
    } else {
      setInput(input + value);
    }
  };

  const renderInput = () => {
    if (input.length === 0) {
      return <span className="input-placeholder">0</span>;
    } else {
      return <span className="input-value">{input}</span>;
    }
  };

  return (
    <div className="numerator-container">
      <div className="numerator-input">{renderInput()}</div>
      <div className="numerator-buttons">
        <div className="numerator-row">
          {[1, 2, 3].map((num) => (
            <button
              key={num}
              className="numerator-button"
              onClick={() => handleClick(num)}
            >
              {num}
            </button>
          ))}
        </div>
        <div className="numerator-row">
          {[4, 5, 6].map((num) => (
            <button
              key={num}
              className="numerator-button"
              onClick={() => handleClick(num)}
            >
              {num}
            </button>
          ))}
        </div>
        <div className="numerator-row">
          {[7, 8, 9].map((num) => (
            <button
              key={num}
              className="numerator-button"
              onClick={() => handleClick(num)}
            >
              {num}
            </button>
          ))}
        </div>
        <div className="numerator-row">
          <button
            className="numerator-button numerator-delete"
            onClick={() => handleClick("delete")}
          >
            {t("delete")}
          </button>
          <button className="numerator-button" onClick={() => handleClick(0)}>
            0
          </button>
          <button
            className="numerator-button numerator-enter"
            onClick={() => handleClick("enter")}
          >
            {t("go")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Numerator;
